export default __webpack_public_path__ + "static/marketplace-tag-9d87564de829986191c0a3cc05aa329a.png";